import { powerSyncCollectionOptions } from "@tanstack/powersync-db-collection";
import { createCollection } from "@tanstack/react-db";
import { RoleSchema } from "@vidimo/shared";
import { z } from "zod";
import { AppSchema } from "@/lib/powersync-schema.generated";
import { collectionBase } from "./_factory";
import { serverEnum } from "./server-enum";
import { syncedRow } from "./synced-row";

// `role` is constrained to the 4-tier role taxonomy from @vidimo/shared
// so UI code can rely on the type. Pre-migration `member` rows are mapped
// to `receptionist` by the 0008 migration, so any sync row reaching the
// client should validate cleanly.
// `propertyId` is the tenant key (a property uuid). The PowerSync sync rule
// aliases BetterAuth's `organization_id` SQL column to `propertyId` for the
// client; the column name stays `organization_id` server-side for BetterAuth
// compatibility.
export const SelectMembershipSchema = syncedRow({
  createdAt: z.string(),
  id: z.string(),
  propertyId: z.string().uuid(),
  role: serverEnum(RoleSchema, "operator"),
  userId: z.string(),
});

export type Membership = z.infer<typeof SelectMembershipSchema>;

export const membershipCollection = createCollection(
  powerSyncCollectionOptions({
    ...collectionBase("membership"),
    schema: SelectMembershipSchema,
    table: AppSchema.props.membership,
  })
);
